import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const videoContainer = (theme: Theme) => css`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.surface.overlayBackdrop};
  padding: 0 2rem;
  height: 100vh;
  margin-top: 0;
`;

export const mainPageColumn = css`
  display: flex;
  flex-flow: column;
`;

export const marginRemoved = css`
  margin-top: 0;
  height: 100vh;
`;

export const headerWrapper = css`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media only screen and (min-width: ${dimensions.tablet}) {
    flex-direction: row;
  }
`;

export const stepperDiv = css`
  width: 800px;
  @media (min-width: ${dimensions.desktopMax}) {
    margin-left: 4rem;
  }
`;

export const stepperMobile = css`
  margin-bottom: 1.25rem;
  width: 100%;
`;
